import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { BA_ANNOTATION } from './annotations';

// "Panda usage" entity tab, mirroring the Kubernetes tab (squadK8s): a
// horizontal content tab contributed to the catalog plugin. It only shows on
// entities subscribed to Panda, i.e. those carrying the `agentfact.tdf/ba`
// annotation whose value scopes the CloudWatch metrics (the `ba` dimension).
const pandaUsageContent = EntityContentBlueprint.make({
  name: 'panda-usage',
  params: {
    path: '/panda-usage',
    title: 'Panda usage',
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[BA_ANNOTATION]),
    loader: async () => {
      const { PandaUsageContent } = await import('./PandaUsageContent');
      return <PandaUsageContent />;
    },
  },
});

export const pandaUsageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [pandaUsageContent],
});
